module.exports = __webpack_public_path__ + "static/media/C20-0173_2.50_Mama_Burger_Mobile_767x845.71d4397c.jpg";